export default __webpack_public_path__ + "7fc686695bf14259d41c96de63a8a17b.png";